"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _star = _interopRequireDefault(require("../assets/images/star.svg"));

var _arrowRightYellow = _interopRequireDefault(require("../assets/images/arrow-right-yellow.svg"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  background: none;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  font-size: 1.2rem;\n  min-width: 100%;\n  text-align: left;\n  align-items: center;\n  justify-content: flex-start;\n  border: none;\n  outline: none;\n\n  ", ", ", " {\n    display: inline-block;\n  }\n\n  ", ", ", " {\n    position: relative;\n  }\n\n  /* Focus styles are on keyboard focus */\n  &:hover,\n  &[data-focus-visible-added]:focus {\n    color: ", ";\n    text-decoration-color: currentcolor;\n    text-decoration-line: underline;\n  }\n\n  &[data-focus-visible-added]:focus {\n    ", "\n    outline-offset: 2px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    min-width: auto;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.3rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) and (max-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  content: '';\n  background: url(", ") no-repeat;\n  background-size: 100% 100%;\n  width: 7px;\n  height: 9px;\n  margin-left: 15px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: url(", ") no-repeat;\n  background-size: 100% 100%;\n  width: 16px;\n  height: 14px;\n  margin-right: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Although this is a button, we used the link focus and hover styles to maintain consistency with the telephone link in TwoColumnMainMenu
 */
var stateColors = (0, _styledTheming.default)('mode', {
  figure: _Constant.Color.FOCUS_B,
  pella: _Constant.Color.FOCUS_B,
  petersendean: _Constant.Color.FOCUS_B
});
var focusStyles = (0, _styledTheming.default)('mode', {
  caliber: "outline: 1px solid ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";"),
  homepoint: "outline: 1px solid ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";"),
  figure: "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";"),
  pella: "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";"),
  petersendean: "outline: 1px solid ".concat(_Constant.Color.FOCUS_B, ";")
});

var StarIcon = _styledComponents.default.span(_templateObject(), _star.default);

var ArrowIcon = _styledComponents.default.span(_templateObject2(), _arrowRightYellow.default);

var LongText = _styledComponents.default.span(_templateObject3(), _Constant.Width.MD, _Constant.Width.LG - 1);

var Button = _styledComponents.default.button(_templateObject4(), StarIcon, ArrowIcon, StarIcon, ArrowIcon, stateColors, focusStyles, _Constant.Width.MD, _Constant.Width.LG);

var FeedbackLink = function FeedbackLink(_ref) {
  var handleClick = _ref.handleClick,
      props = (0, _objectWithoutProperties2.default)(_ref, ["handleClick"]);
  return /*#__PURE__*/_react.default.createElement(Button, (0, _extends2.default)({
    onClick: handleClick
  }, props), /*#__PURE__*/_react.default.createElement(StarIcon, null), /*#__PURE__*/_react.default.createElement("span", null, "Share your feedback ", /*#__PURE__*/_react.default.createElement(LongText, null, "with the CEO")), /*#__PURE__*/_react.default.createElement(ArrowIcon, null));
};

FeedbackLink.propTypes = {
  handleClick: _propTypes.default.func.isRequired
};
FeedbackLink.displayName = 'FeedbackLink';
var _default = FeedbackLink;
exports.default = _default;